import {I18n} from 'aws-amplify/utils';

import {
    ReloadButton,
    SimplePageHeader,
} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useApplicationProducts} from '@flexinet/pricing-components';

const ComponentsReloadButton = () => {

    const {handleFetchRecords} = useApplicationProducts();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => handleFetchRecords()}/>
        </Box>
    );
};

const useTools = () => {
    const tools = [<ComponentsReloadButton key='reload'/>];
    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('ApplicationProducts')}
            tools={useTools()}
        />
    );
};
